import { types } from './device.action';

export interface stateInterface {
  isMobileView: boolean;
}

const initialState: stateInterface = {
  isMobileView: false
};

export default function reducer(state = initialState, action: any) {
  switch (action.type) {
    case types.APP_IS_MOBILE:
      return {
        ...state,
        isMobileView: action.payload
      };
    default:
      return state;
  };
}
